import Helpers from "../../resources/js/utils/helpers";
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';

export default class Map extends Helpers {
  constructor() {
    super();
    this.mapSection = document.querySelector('.map');
    if (!this.mapSection) return;
    this.mapBlock = this.mapSection.querySelector('.map__block');
    if (!themeVars.mapToken || !this.mapBlock) return;

    this.inputSearch = this.mapSection.querySelector('.map__search-form-search-input');
    this.loadSpinner = this.mapSection.querySelector('.spinner-load');
    this.mapLoader = this.mapSection.querySelector('.js-map-loader');
    this.filterResultList = this.mapSection.querySelector('.js-list-result-filter');
    this.wrapperListResult = this.mapSection.querySelector('.map__search-results-list');

    mapboxgl.accessToken = themeVars.mapToken;
    this.points = [];
    this.map = null;
    this.defaultMarker = '';
    this.catIds = [];
    this.value = '';
    this.debounceTimer = null;
    this.isLoadFilter = false;

    this.loadPosts().then(() => {
      this.initMap();
      this.initFilterMap();
      const mapboxLogoLink = document.querySelector('.mapboxgl-ctrl-logo');
      if (mapboxLogoLink) {
        mapboxLogoLink.innerHTML = '<span style="position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;">Mapbox</span>';
      }
    });
  }

  debouncedApplyFilters() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.filterMap(this.value, this.catIds);
    }, 800);
  }

  clickItemResult(el) {
    if (!el.dataset.lng || !el.dataset.lat) return;
    this.setNewCenter([parseFloat(el.dataset.lng), parseFloat(el.dataset.lat)]);
  }

  initFilterMap() {
    Helpers.registerHandler('click', this.handleFilter.bind(this), '.map__categories-item');
    Helpers.registerHandler('click', this.clickItemResult.bind(this), '.js-post-result-item');
    if (this.inputSearch) {
      this.inputSearch.addEventListener('input', (event) => {
        this.value = event.target.value.trim();
        this.debouncedApplyFilters();
      });
    }
  }

  async handleFilter(el) {
    const id = el.getAttribute('data-category-id');
    if (!id) return;
    el.classList.toggle('is-active');
    if (this.catIds.includes(id)) {
      this.catIds = this.catIds.filter(itemId => itemId !== id);
    } else {
      this.catIds.push(id);
    }
    this.debouncedApplyFilters();
  }

  async filterMap(value = '', catIds = []) {
    if (this.isLoadFilter) return;
    try {
      this.isLoadFilter = true;
      this.loadSpinner.classList.add('show');
      this.popup.remove();

      if (!value && catIds.length === 0) {
        this.wrapperListResult.classList.remove('is-active');
        this.filterResultList.innerHTML = '';
        this.updatePoints(this.points);
        this.fitToPoints(this.points);
        return;
      }

      const result = await this.ajaxFetchPost({
        action: 'ajax_filter_map',
        value,
        categories: catIds,
      });

      if (result.success) {
        this.updatePoints(result.data.posts);
        this.fitToPoints(result.data.posts);
        this.filterResultList.innerHTML = result.data.html;
        this.wrapperListResult.classList.add('is-active');
      }
    } catch (e) {
      console.error(e, 'filter error');
    } finally {
      this.isLoadFilter = false;
      this.loadSpinner.classList.remove('show');
    }
  }

  async loadPosts() {
    const resp = await this.ajaxFetchGet({action: 'ajax_init_map'});
    if (resp.success && resp.data.posts.length > 0) {
      this.points = resp.data.posts;
      this.defaultMarker = resp.data.defaultMarker;
    }
  }

  setNewCenter(center = [13.550343, 54.665957]) {
    this.map.flyTo({
      center: center,
      zoom: 14,
      speed: 1.2,
    });
  }

  initMap() {
this.map = new mapboxgl.Map({
  container: this.mapBlock,
  style: 'mapbox://styles/mapbox/light-v11',
  center: [15, 50],  // fixed Europe overview
  zoom: 3,
  projection: 'mercator',
  attributionControl: false,
});
this.map.on('style.load', () => {
  const layers = this.map.getStyle().layers;
  layers.forEach((layer) => {
    if (layer.layout && layer.layout['text-field']) {
      this.map.setLayoutProperty(layer.id, 'text-field', [
        'coalesce',
        ['get', 'name_es'],
        ['get', 'name'],
      ]);
    }
  });
});
    this.popup = new mapboxgl.Popup({
      offset: 15,
      closeButton: true,
      closeOnClick: true,
      autoPanPadding: 50,
    });

    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
      showZoom: true,
    });
    this.map.addControl(nav, 'top-right');

    this.map.on('load', async () => {
      await this.loadMarkerImages();

      const features = this.points.map((p) => {
        const lng = parseFloat(p.lng);
        const lat = parseFloat(p.lat);

        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [lng, lat],
          },
          properties: {id: p.id, icon: p.icon || 'default-marker'},
        };
      });

      this.map.addSource('points', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
        cluster: true,
        clusterRadius: 50,
        buffer: 0,
        maxzoom: 14,
      });

  // Fixed Europe overview, independent of container size and data points
  this.map.fitBounds(
    [
      [-25, 34],  // southwest: roughly Azores / North Africa coast
      [40, 71],   // northeast: roughly Urals / North Norway
    ],
    { padding: 0, duration: 0 }
  );
		
		
      //this.fitToPoints(this.points);
      this.addClusterLayers();
    });

    this.map.once('idle', () => {
      if (this.mapLoader) this.mapLoader.classList.add('is-hidden');
    });

    this.map.on('click', 'clusters', (e) => {
      const features = this.map.queryRenderedFeatures(e.point, {layers: ['clusters']});
      const clusterId = features[0].properties.cluster_id;
      this.map.getSource('points').getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) return;
        this.map.easeTo({
          center: features[0].geometry.coordinates,
          zoom,
        });
      });
    });

    this.map.on('click', 'unclustered-point', async (e) => {
      const feature = e.features[0];
      const coordinates = feature.geometry.coordinates.slice();
      const {id} = feature.properties;

      this.popup
        .setLngLat(coordinates)
        .setHTML(`<div class="map-popup-point map-popup-loading"><span class="spinner"></span></div>`)
        .addTo(this.map);

      try {
        const response = await this.ajaxFetchGet({
          action: 'ajax_load_post_info',
          post_id: id,
        });
        if (!response?.success) {
          this.popup.setHTML('<div class="map-popup-point">Error</div>');
          return;
        }
        this.popup.setHTML(response.data.html);
        this.popup.remove();
        this.popup.addTo(this.map);
      } catch (err) {
        console.error(err, 'popup error');
      }
    });
  }

  async loadMarkerImages() {
    const defaultPromise = this.loadImage(this.defaultMarker, 'default-marker');
    const uniqueIcons = [...new Set(this.points.map(p => p.icon).filter(Boolean))];
    const iconPromises = uniqueIcons.map(url => this.loadImage(url, url));
    await Promise.all([defaultPromise, ...iconPromises]);
  }

  loadImage(url, id) {
    return new Promise((resolve) => {
      if (!url) return resolve();
      if (this.map.hasImage(id)) return resolve();

      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;

      img.onload = () => {
        if (!this.map.hasImage(id)) {
          this.map.addImage(id, img);
        }
        resolve();
      };

      img.onerror = () => {
        console.warn(`Error load icon: ${url}`);
        resolve();
      };
    });
  }

  updatePoints(points) {
    const features = (points && points.length > 0)
      ? points.map(p => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [parseFloat(p.lng), parseFloat(p.lat)],
        },
        properties: {
          id: p.id,
          icon: p.icon || 'default-marker',
        },
      }))
      : [];

    const source = this.map.getSource('points');
    if (source) {
      source.setData({type: 'FeatureCollection', features: features});
    }
  }

  fitToPoints(points) {
    if (!points || points.length === 0) return;

    const bounds = new mapboxgl.LngLatBounds();
    let validPoints = 0;

    points.forEach(p => {
      const lng = parseFloat(p.lng);
      const lat = parseFloat(p.lat);
      if (!isNaN(lng) && !isNaN(lat)) {
        bounds.extend([lng, lat]);
        validPoints++;
      }
    });

    if (validPoints === 0) return;

    if (validPoints === 1) {
      this.map.flyTo({
        center: [parseFloat(points[0].lng), parseFloat(points[0].lat)],
        zoom: 10,
        speed: 1.2,
      });
    } else {
      this.map.fitBounds(bounds, {
        padding: 80,
        maxZoom: 12,
        duration: 1200,
      });
    }
  }

  addClusterLayers() {
    this.map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'points',
      filter: ['has', 'point_count'],
      maxzoom: 22,
      paint: {
        'circle-color': '#EA352B',
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
      },
    });

    this.map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'points',
      filter: ['has', 'point_count'],
      maxzoom: 22,
      layout: {
        'text-field': ['get', 'point_count_abbreviated'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 18,
      },
      paint: {'text-color': '#ffffff'},
    });

    this.map.addLayer({
      id: 'unclustered-point',
      type: 'symbol',
      source: 'points',
      filter: ['!', ['has', 'point_count']],
      maxzoom: 22,
      layout: {
        'icon-image': [
          'coalesce',
          ['image', ['get', 'icon']],
          ['image', 'default-marker'],
        ],
        'icon-size': 1,
        'icon-allow-overlap': true,
        'icon-anchor': 'bottom',
      },
    });
  }
}

new Map();
